//Cores
import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, Inject, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
// Materials
import { MatDialogRef, MatPaginator, MatSort, MAT_DIALOG_DATA } from '@angular/material';
// Services
// Models
//Datasources
// RXJS
import { merge, BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { QueryParamsModel, LayoutUtilsService } from 'app/core/_base/crud';
import { SelectionModel } from '@angular/cdk/collections';
import { ListDialogService } from '../Services/list-dialog.service';
import { ListDialogDataSource } from '../Model/data-sources/list-dialog.datasource';
import { HangHoaModel } from '../Model/hang-hoa.model';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';


@Component({
	selector: 'm-chon-nhieu-hang-hoa-tong-hop-list-dialog',
	templateUrl: './chon-nhieu-hang-hoa-tong-hop-list-dialog.component.html',
})
export class ChonNhieuHangHoaTongHopListDialogComponent implements OnInit {
	item: HangHoaModel;
	dataSource: ListDialogDataSource;
	displayedColumns = [];
	availableColumns = [
		{
			stt: 0,
			name: 'select',
			displayName: 'Check chọn',
			alwaysChecked: true,
			isShow: true
		},
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'Mahh',
			displayName: 'Mã hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'Tenhh',
			displayName: 'Tên hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'QuyCach',
			displayName: 'Quy cách',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'Tendvt',
			displayName: 'ĐVT',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'Tennhomhh',
			displayName: 'Nhóm hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'Maloaihh',
			displayName: 'Mã loại hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 6,
			name: 'Tenloaihh',
			displayName: 'Tên loại hàng',
			alwaysChecked: false,
			isShow: true
		},
		
	];
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	hasFormErrors: boolean = false;
	viewLoading: boolean = false;
	loadingAfterSubmit: boolean = false;
	//===================================Khai báo dữ liệu===================
	//=======================================================================
	// Filter fields
	@ViewChild('searchFullText', { static: true }) searchFullText: ElementRef;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild(MatSort, { static: true }) sort: MatSort;
	disabledKho: boolean = false;
	IdKho: string = '0';
	selectedValue: any;

	selection = new SelectionModel<any>(true, []);
	productsResult: any[] = [];
	disabledBtn: boolean = false;
	fixedPoint = 2;
	listKho: any[] = [];
	formSelected: any[] = [];
	Selected: any[] = [];
	CONFIG: CommonConFig;
	constructor(public dialogRef: MatDialogRef<ChonNhieuHangHoaTongHopListDialogComponent>,
		private service: ListDialogService,
		private changeDetectorRefs: ChangeDetectorRef,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private layoutUtilsService: LayoutUtilsService) {
		this.dialogRef.disableClose = true;
	}
	@HostListener('document:keydown', ['$event'])
	onKeydownHandler(event: KeyboardEvent) {
		
		if (event.key === 'Enter') //phím Enter
		{
			this.LoadDataList();
		}
	}
	/** LOAD DATA */
	ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.ListKho();
		if (this.data) {
			if (this.data.IdKho)
				this.IdKho = '' + this.data.IdKho;
			if (this.data.disabledKho)
				this.disabledKho = this.data.disabledKho;
			if (this.data.disabledKho)
				this.disabledKho = this.data.disabledKho;
			if (this.data.selected) {
				this.formSelected = this.data.selected;
				//this.formSelected.forEach(x=>{

				//})
			}
		}
		this.item = new HangHoaModel();

		this.applySelectedColumns();
		// If the user changes the sort order, reset back to the first page.
		this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

		/* Data load will be triggered in two cases:
		- when a pagination event occurs => this.paginator.page
		- when a sort event occurs => this.sort.sortChange
		**/
		merge(this.sort.sortChange, this.paginator.page)
			.pipe(
				tap(() => {
					this.selection.clear();
					this.LoadDataList(true);
				})
			)
			.subscribe();

		// Init DataSource
		this.dataSource = new ListDialogDataSource(this.service, this.layoutUtilsService);

		//Load unit list
		this.LoadDataList();
		this.dataSource.entitySubject.subscribe(res => {
			this.productsResult = res;
			if (this.productsResult.length > 0) {
				if (this.formSelected.length > 0) {
					for (var i = this.formSelected.length - 1; i >= 0; i--) {
						let x = this.formSelected[i];
						
						let index = this.productsResult.findIndex(item => x.IdHh == item.IdHh 
								&& (item.DataDvt && item.DataDvt.IdDvt == x.Dvt) 
								&& (item.DataKho && x.IdKho == item.DataKho.IdKho) 
								&& x.IdLo == item.IdLo 
								&& x.ViTriKho == item.ViTriKho
								&& x.SoMay == item.SoMay
								&& x.MaSub == item.MaSub
								&& x.NgayNhap == item.NgayNhap
								&& (x.ChoPhepXuatKho == item.ChoPhepXuatKho)
							);

						console.log(this.productsResult[0], x);
						if (index >= 0) {
							this.selection.select(this.productsResult[index]);
							this.Selected.push(this.productsResult[index]);
							this.formSelected.splice(i, 1);
						}
					};
				}
				if (this.Selected.length > 0) {
					this.Selected.map((x, index) => {
						let i = this.findIndex(this.productsResult, x);
						if (i >= 0) {
							this.selection.select(this.productsResult[i]);
						}
					});
				}
			}
		});
		this.layoutUtilsService.setUpPaginationLabels(this.paginator);
	}
	//=============================================================================
	/** FILTRATION */
	ListKho() {
		this.service.listKho().subscribe(res => {
			if (res && res.status === 1) {
				this.listKho = res.data;
			}
			this.changeDetectorRefs.detectChanges();
		});
	}
	filterConfiguration(): any {
		const filter: any = {};
		// const searchText: string = this.searchInput.nativeElement.value;
		// filter.keyword = searchText;
		filter.IdKho = this.IdKho;
		filter.FullSearch = this.searchFullText.nativeElement.value;
		filter.filterQuyen = '1';
		filter.ExcludeHh = this.data.ExcludeHh;	
		return filter;
	}

	/** ACTIONS */
	LoadDataList(page: boolean = false) {
		this.selection.clear();
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			page ? this.paginator.pageIndex : this.paginator.pageIndex = 0,
			this.paginator.pageSize
		);
		this.dataSource.loadList_AllProduct(queryParams);
	}

	//chọn cán bộ
	selectItems(_item: HangHoaModel) {
		this.dialogRef.close({
			_item
		});
	}

	onAlertClose($event) {
		this.hasFormErrors = false;
	}

	close() {
		this.dialogRef.close();
	}

	findIndex(arr: any[], x: any) {
		// let index = arr.findIndex(item => x.IdHh == item.IdHh 
		// 		&& x.IdDvt == item.Dvt 
		// 		&& x.IdKho == item.IdKho 
		// 		&& x.IdLo == item.IdLo 
		// 		&& x.ViTriKho == item.ViTriKho
		// 		&& x.SoMay == item.SoMay
		// 		&& x.MaSub == item.MaSub
		// 		&& x.NgayNhap == item.NgayNhap
		// 		&& x.ChoPhepXuatKho == item.ChoPhepXuatKho
		// 		&& x.MaThung == item.MaThung
		// 		&& x.SoMeSoXe == item.SoMeSoXe
		// 	);
		let index = arr.findIndex(item => item.IdTk == x.IdTk
		);
		return index;
	}

	/** SELECTION */
	checkedChange(event, x) {
		if (event)
			this.selection.toggle(x);
		if (event.checked) {
			this.Selected.push(x);
		} else {
			let index = this.findIndex(this.Selected, x);
			if (index >= 0) {
				this.Selected.splice(index, 1);
			}
		}
	}
	isAllSelected() {
		const numSelected = this.selection.selected.length;
		const numRows = this.productsResult.length;
		return numSelected === numRows;
	}

	/** Selects all rows if they are not all selected; otherwise clear selection. */
	masterToggle() {
		if (this.isAllSelected()) {
			this.selection.selected.forEach(x => {
				let index = this.findIndex(this.Selected, x);
				if (index >= 0) {
					this.Selected.splice(index, 1);
				}
			});
			this.selection.clear();
		} else {
			this.productsResult.forEach(x => {
				let index = this.findIndex(this.Selected, x);
				if (index < 0) {
					this.Selected.push(x);
				}
				this.selection.select(x);
			});
		}
	}

	IsAllColumnsChecked() {
		const numSelected = this.selectedColumns.selected.length;
		const numRows = this.availableColumns.length;
		return numSelected === numRows;
	}
	CheckAllColumns() {
		if (this.IsAllColumnsChecked()) {
			this.availableColumns.forEach(row => { if (!row.alwaysChecked) this.selectedColumns.deselect(row); });
		} else {
			this.availableColumns.forEach(row => this.selectedColumns.select(row));
		}
	}

	applySelectedColumns() {
		const _selectedColumns: string[] = [];
		this.selectedColumns.selected.sort((a, b) => { return a.stt > b.stt ? 1 : 0; }).forEach(col => { _selectedColumns.push(col.name) });
		this.displayedColumns = _selectedColumns;
	}

	goBack(id = 0) {
		var sl = this.Selected.length + this.formSelected.length;
		if (sl > 0 && id == 1)
			this.dialogRef.close({ done: true, Selected: this.Selected, FormSelected: this.formSelected });
		else
			this.dialogRef.close({ done: false, Selected: [], FormSelected: [] });
	}

	luuNhanVien() {
		this.goBack(1);
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_number(item: any = "0.00") {
		return FunctionPublic.F_NUMBER_DYNAMIC(item, FunctionPublic.MAX_POINT);
	}
	getFormatDate(v: string = '') {
		if (v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1 $7:$9:$11") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1 ");
		}
		return '';
	}
}
